            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">      
                <b-form  inline style="margin-bottom:15px" novalidate> 
                  <b-row style="width:100%;margin-bottom:20px"  v-if="dataForm[namePath].info_aportes.id_list_forma!==1">                      
                    <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_datos_razon"
                          inline
                          disabled
                          :md="5" :lg="5">
                        </sw-inputs>                     
                        <sw-inputs
                          v-if="openModal.modal.data.mes_periodo===dataForm[namePath].info_afiliacion.mes_periodo && openModal.modal.data.ano_periodo===dataForm[namePath].info_afiliacion.ano_periodo"
                          inputTabla="info_aportes"
                          inputCampo="id_list_forma"
                          inline                          
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="4" :lg="4">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>  
                        <sw-inputs
                          v-if="openModal.modal.data.mes_periodo!==dataForm[namePath].info_afiliacion.mes_periodo ||openModal.modal.data.ano_periodo!==dataForm[namePath].info_afiliacion.ano_periodo"
                          :filter="{id: 2, name: 'Mensajeria'}"
                          inputTabla="info_aportes"
                          inputCampo="id_list_forma"
                          inline                          
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="4" :lg="4">                         
                        </sw-inputs>                        
                        <sw-inputs
                          class=" d-none"
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="label_consecutivo"
                          :showLabel="false"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                     
                       
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="descripcion"
                          inline
                          :md="9" :lg="9">
                        </sw-inputs>
                         <sw-inputs
                          v-if="user.admin===1"
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="fecha"
                          :showLabel="false"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs> 
                        <b-col v-else :md="3" :lg="3" style="margin-top: -5px;">
                         {{fechaPago}}
                          <b-form-checkbox
                            v-if="dataForm[namePath].info_afiliacion.ano_periodo!=fecha().fecha.anoHoy || dataForm[namePath].info_afiliacion.mes_periodo!=fecha().fecha.mesHoy"
                            @input="changeFecha"
                            v-model="fechaAdelantado"
                            name="checkbox-1"
                            >
                            1 día mes aporte
                          </b-form-checkbox>
                        </b-col> 
                  </b-row>  
                  <b-row style="width:100%;margin-bottom:20px" v-if="dataForm[namePath].info_aportes.id_list_forma===1">                      
                    <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_datos_razon"
                          inline
                          disabled
                          :md="5" :lg="5">
                        </sw-inputs>                     
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_forma"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="4" :lg="4">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>                           
                        <sw-inputs
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="label_consecutivo"
                          class=" d-none"
                          :showLabel="false"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs>        
                        <b-col :md="5" :lg="5">
                        </b-col>                                          
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_cuentas"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar cuenta"
                          modalSize="sm"
                          :md="4" :lg="4">
                          <template v-slot:modal="modalInput">
                            <sw-modallistcuentas
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistcuentas>
                          </template>
                        </sw-inputs>   
                        <b-col :md="3" :lg="3">
                        </b-col>   
                        <b-col :md="5" :lg="5">
                        </b-col>     
                        <sw-inputs
                          style="margin-bottom:10px"
                          inputTabla="info_aportes"
                          inputCampo="consignacion"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="descripcion"
                          inline
                          :md="9" :lg="9">
                        </sw-inputs>                           
                         <sw-inputs
                          v-if="user.admin===1"
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="fecha"
                          :showLabel="false"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs> 
                        <b-col v-else :md="3" :lg="3" style="margin-top: -5px;">
                         {{fechaPago}}
                          <b-form-checkbox
                            v-if="dataForm[namePath].info_afiliacion.ano_periodo!=fecha().fecha.anoHoy || dataForm[namePath].info_afiliacion.mes_periodo!=fecha().fecha.mesHoy"
                            @input="changeFecha"
                            v-model="fechaAdelantado"
                            name="checkbox-1"
                            >
                            1 día mes aporte
                          </b-form-checkbox>
                        </b-col>  
                  </b-row>
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0">
                    <b-col md="6">
                        <span style="font-weight: 500;display:inline-block;width:80px">Contacto:</span> {{dataForm[namePath].info_aportes.name}}<br>
                        <span style="font-weight: 500;display:inline-block;width:80px">Dirección:</span> {{dataForm[namePath].info_aportes.direccion}} <br>
                        <span style="font-weight: 500;display:inline-block;width:80px">Teléfonos:</span> {{dataForm[namePath].info_aportes.telefonos}}<br>
                    </b-col>  
                    <b-col md="6">
                        <span style="font-weight: 500;display:inline-block;width:100px">Documento:</span> {{dataForm[namePath].info_aportes.documento}} <br>     
                        <span style="font-weight: 500;display:inline-block;width:100px">Correo:</span> {{dataForm[namePath].info_aportes.email}} <br>                      
                        <span style="font-weight: 500;display:inline-block;width:100px"> Asesor:</span>  Oficina<br>                        
                     </b-col> 
                  </b-row>  
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0; margin-top:10px">
                    <b-col md="6" style="text-align:justify">
                        <span style="font-weight: 500;display:inline-block;width:80px; ">Concepto:</span> {{dataForm[namePath].info_aportes.descripcion}} {{serviciosDescripcion}}
                    </b-col>  
                    <b-col :md="3">
                        <span style="font-weight: 500;display:inline-block;width:100px">Valor:</span> <span style="float:right">{{dataForm[namePath].info_aportes.valor}}</span> <br>
                        <span style="font-weight: 500;display:inline-block;width:100px" v-if="dataForm[namePath].descuentos_referido!=null">D/to referido:</span> <span style="float:right" v-if="dataForm[namePath].descuentos_referido!=null">{{dataForm[namePath].descuentos_referido.descuento}}</span> <br>
                        <span v-if="dataForm[namePath].descuentos_referido!=null" style="font-weight: 500;display:inline-block;width:100px">Total:</span> <span v-if="dataForm[namePath].descuentos_referido!=null" style="float:right">{{dataForm[namePath].info_aportes.valor-dataForm[namePath].descuentos_referido.descuento}}</span> <br>
                    </b-col>      
                    <b-col :md="3">
                        <b-form-checkbox
                          @input="changeReporte"
                          v-model="reporte"
                          name="checkbox-1"
                          >
                          Solo admin de asesor
                        </b-form-checkbox>
                        <b-form-checkbox
                          @input="changeValor0"
                          v-model="valor0"
                          name="checkbox-1"
                          >
                          Valor en 0
                        </b-form-checkbox>
                    </b-col>             
                  </b-row>  
                  <b-row style="width:100%">                                
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="observacion"
                      :md="12" :lg="12">
                    </sw-inputs>
                  </b-row>    
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn=""
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import moment from 'moment'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas  
  },
  props: {
  },
  data()
  {
    return {
      fechaPago: null,
      valor0:false,
      fechaAdelantado:null,
      valor: 0,
      reporte: false,
      valorReporte: 0,
      createdCycle: true,
      active: 1,
      infoDescripcion: '',  
      serviciosDescripcion: '',      
      claseriesgo: null,
      ibc: {
        Afp: null,
        Ccf: null,
        Eps: null,
        Riesgo: null,
      },
      tarifa:{ 
        Afp: null,
        Eps: null,
        Riesgo: null,
        Ccf: null,
      },
      cotizacion: { 
        Afp: null,
        Eps: null,
        Riesgo: null,
        Ccf: null,
      },
      codigo: {
        Ccf: null,
        Afp: null,
        Eps: null,
      },
      saveEvent:false,
      totalAportes: 0,
      ultimoDataForm: {}
    }
  },
  async updated()
  {    
    await this.resetDataForm({state: 'info_aportes/descripcion'})
  },
  async created(){
    this.fechaPago=this.fecha().fecha.minHoy
    if(this.namePath==='aportes_registrar')
    {
      if(this.dataIndex[this.namePath]!==false && this.dataIndex[this.namePath]!==10000)
      {
        await this.updateDataForm({state: 'datos_afiliado', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado})
        await this.updateDataForm({state: 'info_afiliacion', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion})
      }  
      else 
      {
        this.ultimoDataForm = await this.deepCopy(this.dataForm[this.namePath])
        let serviciosArchivo_plano = ''
        await this.resetDataForm({state: 'info_aportes'})
        await this.updateDataIndex({ data: 10000})
        let asesorData = this.gettersDatalist('datos_asesor',this.dataForm[this.namePath].info_afiliacion.id_datos_asesor)
        let j=0
        for (let i = 0; i < this.dataForm[this.namePath].servicios_activos.length; i++) {   
          if(this.dataForm[this.namePath].servicios_activos[i].name_list!=='' && this.dataForm[this.namePath].servicios_activos[i].name_list!==null)
          {
            let nameLista = await this.gettersDatalist(this.dataForm[this.namePath].servicios_activos[i].name_list,this.dataForm[this.namePath].servicios_activos[i].id_list)[0]  
            
            if(this.dataForm[this.namePath].servicios_activos[i].name!=='Traslado')
            {
              if(this.dataForm[this.namePath].servicios_activos[i].name==='Riesgo')
              {             
                let razonData = this.gettersDatalist('datos_razon',this.dataForm[this.namePath].info_afiliacion.id_datos_razon)  
                this.serviciosDescripcion = this.serviciosDescripcion+' ARL '+this.gettersDatalist('list_arl',razonData[0].id_list_arl)[0].name 
              }  
              this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_activos[i].name+' '+nameLista.name            
            }
            
            if(this.dataForm[this.namePath].servicios_activos[i].name==='Eps' || this.dataForm[this.namePath].servicios_activos[i].name==='Ccf' || this.dataForm[this.namePath].servicios_activos[i].name==='Afp'  )
            {              
              serviciosArchivo_plano = serviciosArchivo_plano+' '+this.dataForm[this.namePath].servicios_activos[i].name+' '+nameLista.name
              this.codigo[this.dataForm[this.namePath].servicios_activos[i].name]=nameLista.codigo
              this.ibc[this.dataForm[this.namePath].servicios_activos[i].name]=parseInt((this.dataForm[this.namePath].info_afiliacion.salario/30)*this.dataForm[this.namePath].info_afiliacion.dias)
              if(this.dataForm[this.namePath].servicios_activos[i].name==='Eps')
              {
                if(this.dataForm[this.namePath].info_afiliacion.exonerado===1)
                { 
                  this.tarifa.Eps=this.dataForm[this.namePath].base[0].epsexo
                }
                else {
                  this.tarifa.Eps=this.dataForm[this.namePath].base[0].epsnoexo
                }
                this.cotizacion.Eps=this.redondeaValue(100,this.ibc.Eps*(this.tarifa.Eps/100),1)+this.ibc.Eps*(this.tarifa.Eps/100)
                this.totalAportes=this.totalAportes+this.cotizacion.Eps
              }
              
              if(this.dataForm[this.namePath].servicios_activos[i].name==='Afp')
              {                
                this.tarifa.Afp=this.dataForm[this.namePath].base[0].afp
                this.cotizacion.Afp=this.redondeaValue(100,this.ibc.Afp*(this.tarifa.Afp/100),1)+this.ibc.Afp*(this.tarifa.Afp/100)
                this.totalAportes=this.totalAportes+this.cotizacion.Afp
              }            

              if(this.dataForm[this.namePath].servicios_activos[i].name==='Ccf')
              {       
                let razonData= this.gettersDatalist('datos_razon',this.dataForm[this.namePath].info_afiliacion.id_datos_razon)[0]  
                if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3 && razonData.retiroparafiscales===1)
                {
                  let inicioccf = this.dataForm[this.namePath].servicios_activos[i].iniciolabores
                  if(inicioccf===null)
                  {
                    inicioccf=this.dataForm[this.namePath].info_afiliacion.ingreso
                  }
                  let fecha1=moment(inicioccf)
                  let fecha2=moment(this.dataForm[this.namePath].info_afiliacion.retiro)
                  let dias=parseInt(fecha2.diff(fecha1,'days'))+1
                  if(dias<1) { dias=1;}
                  this.ibc.Ccf=this.ibc.Ccf+parseInt(this.dataForm[this.namePath].info_afiliacion.salario*dias/720)
                }
                this.tarifa.Ccf=this.dataForm[this.namePath].base[0].ccf
                this.cotizacion.Ccf=this.redondeaValue(100,this.ibc.Ccf*(this.tarifa.Ccf/100),1)+this.ibc.Ccf*(this.tarifa.Ccf/100)
                this.totalAportes=this.totalAportes+this.cotizacion.Ccf
              }
            }
            if(this.dataForm[this.namePath].servicios_activos[i].name==='Riesgo')
            {
              serviciosArchivo_plano = serviciosArchivo_plano+' '+this.dataForm[this.namePath].servicios_activos[i].name+' '+nameLista.name
              this.codigo.Riesgo=nameLista.codigo
              this.ibc.Riesgo=parseInt((this.dataForm[this.namePath].info_afiliacion.salario/30)*this.dataForm[this.namePath].info_afiliacion.dias)
              this.claseriesgo=this.dataForm[this.namePath].servicios_activos[i].id_list
              this.tarifa.Riesgo=this.dataForm[this.namePath].base[0]['r'+this.dataForm[this.namePath].servicios_activos[i].id_list]
              this.cotizacion.Riesgo=this.redondeaValue(100,this.ibc.Riesgo*(this.tarifa.Riesgo/100),1)+this.ibc.Riesgo*(this.tarifa.Riesgo/100)
              this.totalAportes=this.totalAportes+this.cotizacion.Riesgo
            }
          }
          else 
          { 
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_activos[i].name  
          }   
          switch(this.dataForm[this.namePath].info_afiliacion.id_list_novedad)
          {
            case 1 :
              this.valor = parseInt(this.dataForm[this.namePath].servicios_activos[i].valoringreso)+parseInt(this.valor)
            break 
            case 2 :
              this.valor = parseInt(this.dataForm[this.namePath].servicios_activos[i].valor)+parseInt(this.valor)
            break 
            case 3 :
              this.valor = parseInt(this.dataForm[this.namePath].servicios_activos[i].valorretiro)+parseInt(this.valor)
            break 
            case 4 :
              this.valor = parseInt(this.dataForm[this.namePath].servicios_activos[i].valor)+parseInt(this.valor)
            break 
          }

          if(this.dataForm[this.namePath].servicios_activos[i].name==='Traslado' && this.dataForm[this.namePath].servicios_activos[i].mes_periodo.toString()<=this.dataForm[this.namePath].info_afiliacion.mes_periodo && this.dataForm[this.namePath].servicios_activos[i].ano_periodo.toString()<=this.dataForm[this.namePath].info_afiliacion.ano_periodo)
          {                
            this.dataForm[this.namePath].servicios_activos[i].nota_delete='Se actualiza la eps con la del traslado'
            this.dataForm[this.namePath].servicios_activos[i].deleted_at=this.fecha().fecha.delete
          }
                     
          if(this.dataForm[this.namePath].servicios_activos[i].name==='Afp')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['afp'])
          }               
        }     
        this.updateDataForm({state: 'archivo_plano/servicios', data: serviciosArchivo_plano})
        this.serviciosDescripcion = this.serviciosDescripcion+' del mes de '+this.gettersDatalist('list_mes',this.openModal.modal.data.mes_periodo)[0].name+' del '+this.gettersDatalist('list_ano',this.openModal.modal.data.ano_periodo)[0].name  
        const await20 = this.updateDataForm({state: 'info_aportes/valor', data: this.valor})
        if(this.dataForm[this.namePath].info_afiliacion.id_datos_asesor===1)
        {
          await this.updateDataForm({state: 'info_aportes/comision', data: 0})
        }
        else
        {
          await  this.updateDataForm({state: 'info_aportes/comision', data: 0})
        }
        const await22 = this.updateDataForm({state: 'info_aportes/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
        const await23 = this.updateDataForm({state: 'info_aportes/consecutivo', data: 1552})
        const await24 = this.updateDataForm({state: 'info_aportes/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
        const await25 = this.updateDataForm({state: 'info_aportes/name', data: this.dataForm[this.namePath].datos_afiliado.name})
        const await26 = this.updateDataForm({state: 'info_aportes/documento', data:  this.dataForm[this.namePath].datos_afiliado.documento})
        const await27 = this.updateDataForm({state: 'info_aportes/direccion', data:  this.dataForm[this.namePath].datos_afiliado.direccion})
        const await28 = this.updateDataForm({state: 'info_aportes/telefonos', data:  this.dataForm[this.namePath].datos_afiliado.telefonos})
        const await29 = this.updateDataForm({state: 'info_aportes/email', data:  this.dataForm[this.namePath].datos_afiliado.email})
        const await30 = this.updateDataForm({state:'info_aportes/fecha', data: this.fecha().fecha.minHoy})
        const await31 = this.updateDataForm({state: 'info_aportes/id_list_mes', data:  parseInt(this.openModal.modal.data.mes_periodo)})
        const await32 = this.updateDataForm({state: 'info_aportes/id_list_ano', data:  parseInt(this.openModal.modal.data.ano_periodo)})
        const await33 = this.updateDataForm({state: 'info_aportes/id_list_documento', data:  this.dataForm[this.namePath].datos_afiliado.id_list_documento})
            await Promise.all([await20,await22,await23,await24,await25,await26,await27,await28,await29,await30,await31,await32,await33])
        if(this.openModal.modal.data.mes_periodo!==this.dataForm[this.namePath].info_afiliacion.mes_periodo || this.openModal.modal.data.ano_periodo!==this.dataForm[this.namePath].info_afiliacion.ano_periodo)
        {
          this.updateDataForm({state: 'info_aportes/id_list_forma', data:  5})
        }
        
     } 
    } 
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  destroyed()
  {
    this.updateDataForm({data: this.ultimoDataForm})
    this.resetDataIndex()
  },
  computed: { 
  },
  methods: {
    async changeReporte()
    {
      if(this.reporte===true && this.dataForm[this.namePath].info_afiliacion.id_datos_asesor!==1)
      {     
        let asesorData = this.gettersDatalist('datos_asesor',this.dataForm[this.namePath].info_afiliacion.id_datos_asesor)
        if(asesorData[0].admin>0)
        {
          await this.updateDataForm({state: 'info_aportes/valor', data: asesorData[0].admin})
          this.valor0=false 
        }        
        return true
      }
      if(this.valor0===false)
      {
        await this.updateDataForm({state: 'info_aportes/valor', data: this.valor})
      }
      return true
    },
    async changeValor0()
    {
      if(this.valor0===true)
      { 
        await this.updateDataForm({state: 'info_aportes/valor', data: 0})
        await this.updateDataForm({state: 'info_aportes/comision', data: 0})
        this.reporte=false 
        return true
      }
      if(this.reporte===false)
      {
        await this.updateDataForm({state: 'info_aportes/valor', data: this.valor})
        await this.updateDataForm({state: 'info_aportes/comision', data: 0})
      }
      return true
    },
    async save(event)
    {
      try { 
        if(this.saveEvent)
        {
          let info_aportes= await this.deepCopy(this.dataForm[this.namePath].info_aportes)
          await this.updateDataForm({data: this.ultimoDataForm})
          await this.updateDataForm({state: 'info_aportes', data: info_aportes})
          this.saveEvent=false      
        }
        if(this.saveEvent===false)
        {  
          this.saveEvent=true        
          await this.updateDataForm({state: 'aportes_registro/servicios', data: this.dataForm[this.namePath].servicios_activos})
          await this.resetDataForm({state: 'info_aportes/descripcion'})

          let mesPeriodo=parseInt(this.dataForm[this.namePath].info_afiliacion.mes_periodo)
          let anoPeriodo=parseInt(this.dataForm[this.namePath].info_afiliacion.ano_periodo)

          let mes_periodo=mesPeriodo+1
          let ano_periodo=anoPeriodo

          let diasAportes=this.dataForm[this.namePath].info_afiliacion.dias
          let novedadAportes=this.dataForm[this.namePath].info_afiliacion.id_list_novedad
          

          if(mes_periodo===13)
          {
            mes_periodo=1
            ano_periodo=ano_periodo+1
          }
          // actualizar predeterminado de descripcion
          
          if(this.dataForm[this.namePath].info_aportes.id_list_forma===2 || this.dataForm[this.namePath].info_aportes.id_list_forma===5)
          {
            await this.updateDataForm({state: 'info_aportes/fecha', data: null})
            let serviciosAportes_registro=[]
            for (let l = 0; l < this.dataForm[this.namePath].aportes_registro.servicios.length; l++) {
              let nuevoServicioAporte=this.dataForm[this.namePath].aportes_registro.servicios[l]
              nuevoServicioAporte.mes_periodo=this.dataForm[this.namePath].info_aportes.id_list_mes
              nuevoServicioAporte.ano_periodo=this.dataForm[this.namePath].info_aportes.id_list_ano
              serviciosAportes_registro.push(nuevoServicioAporte);              
            }
            await this.updateDataForm({state: 'aportes_registro/servicios', data: serviciosAportes_registro})
          }
          else 
          {
            if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad!==3)
            {
              for (let k = 0; k < this.dataForm[this.namePath].servicios_activos.length; k++) {
                if(this.dataForm[this.namePath].servicios_activos[k].name!=='Traslado')
                {
                  if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad!==4)
                  {
                    this.dataForm[this.namePath].servicios_activos[k].mes_periodo=mes_periodo
                    this.dataForm[this.namePath].servicios_activos[k].ano_periodo=ano_periodo 
                  } 
                  else if(this.dataForm[this.namePath].servicios_activos[k].name!=='Afp'){
                    this.dataForm[this.namePath].servicios_activos[k].mes_periodo=mes_periodo
                    this.dataForm[this.namePath].servicios_activos[k].ano_periodo=ano_periodo 
                  }
                  else if(this.dataForm[this.namePath].servicios_activos[k].name==='Afp'){                  
                    this.dataForm[this.namePath].servicios_activos[k].nota_delete='Retiro solo pensión'  
                    this.dataForm[this.namePath].servicios_activos[k].deleted_at=this.fecha().fecha.delete
                  }      
                }                 
              }
              this.dataForm[this.namePath].info_afiliacion.mes_periodo=mes_periodo
              this.dataForm[this.namePath].info_afiliacion.ano_periodo=ano_periodo
            }  
            if(this.fechaAdelantado)
            {  
              await this.updateDataForm({state: 'info_aportes/fecha', data: this.fechaPago})
            }      
          }          
          await this.updateDataForm({state: 'info_aportes/descripcion', data: this.dataForm[this.namePath].info_aportes.descripcion+this.serviciosDescripcion})

          let ingresoPlano=null
          let fechaingresoPlano=null
          if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===1)
          {
            ingresoPlano='X'
            fechaingresoPlano=this.dataForm[this.namePath].info_afiliacion.ingreso
            this.dataForm[this.namePath].info_afiliacion.retiro=null
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad=2
            this.dataForm[this.namePath].info_afiliacion.dias=30
          }
          let retiroPlano=null
          let fecharetiroPlano=null
          if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===3)
          {
            retiroPlano='X'
            fecharetiroPlano=this.dataForm[this.namePath].info_afiliacion.retiro

            let fecha11=moment(this.dataForm[this.namePath].info_afiliacion.ingreso)
            let fecha21=moment(this.dataForm[this.namePath].info_afiliacion.retiro)
            let mes_ingreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('MM'))
            let mes_retiro=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.retiro).format('MM'))
            let dias1=parseInt(fecha21.diff(fecha11, 'months'))

            if(dias1===0 && mes_retiro===mes_ingreso)
            {
              ingresoPlano='X'
              fechaingresoPlano=this.dataForm[this.namePath].info_afiliacion.ingreso
            }            

            this.dataForm[this.namePath].info_afiliacion.mes_periodo=mesPeriodo
            this.dataForm[this.namePath].info_afiliacion.ano_periodo=anoPeriodo
            await this.updateDataForm({state: 'info_aportes/descripcion', data: this.dataForm[this.namePath].info_aportes.descripcion+' novedad de retiro'})
            
          }
          let diaspensionPlano=0
          let subtipo=this.dataForm[this.namePath].info_afiliacion.id_list_subtipo
          if(subtipo===1 && this.codigo.Afp!==null)
          {
            diaspensionPlano=diasAportes
          }
          
          if(this.dataForm[this.namePath].info_afiliacion.id_list_novedad===4)
          {
            retiroPlano='P'            
            let mesRetiro = this.dataForm[this.namePath].info_aportes.id_list_mes -1 
            let anoRetiro = this.dataForm[this.namePath].info_aportes.id_list_ano 
            if(mesRetiro===0)
            {
              mesRetiro=12
              anoRetiro=anoRetiro-1
            }
            if(mesRetiro<10)
            {
              mesRetiro='0'+mesRetiro
            }
            fecharetiroPlano=anoRetiro+'-'+mesRetiro+'-30'

            this.dataForm[this.namePath].info_afiliacion.id_list_novedad=2  
            let indexPredeterminado =  _.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': 'info_afiliacion','campo': 'id_list_subtipo', 'id_list_users': this.user.id})            
            
            this.dataForm[this.namePath].info_afiliacion.id_list_subtipo= indexPredeterminado != -1 ? this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado : 4       
          }

          let exonerado='N'
          if(this.dataForm[this.namePath].info_afiliacion.exonerado===1)
          {
            exonerado='S'
          }

          if(this.dataForm[this.namePath].info_aportes.id_list_forma===2 || this.dataForm[this.namePath].info_aportes.id_list_forma===5)
          {
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad=novedadAportes
            this.dataForm[this.namePath].info_afiliacion.dias=diasAportes
            this.dataForm[this.namePath].info_afiliacion.mes_periodo=mesPeriodo
            this.dataForm[this.namePath].info_afiliacion.ano_periodo=anoPeriodo
          }
          
          let fechaArchivo=this.dataForm[this.namePath].info_aportes.fecha
          if((this.dataForm[this.namePath].info_aportes.id_list_mes!==this.fecha().fecha.mesHoy || this.dataForm[this.namePath].info_aportes.id_list_ano!==this.fecha().fecha.anoHoy) && fechaArchivo!==null) 
          {
            fechaArchivo=this.fecha(this.dataForm[this.namePath].info_aportes.id_list_ano+'-'+this.dataForm[this.namePath].info_aportes.id_list_mes+'-01').inicioLabores.servicios
          }
          
          let dataArchivoPlano = { id: null, tipodocumento: this.gettersDatalist('list_documento',this.dataForm[this.namePath].datos_afiliado.id_list_documento)[0].name, documento: this.dataForm[this.namePath].datos_afiliado.documento, nombre1: this.dataForm[this.namePath].datos_afiliado.nombre1, nombre2: this.dataForm[this.namePath].datos_afiliado.nombre2, apellido1: this.dataForm[this.namePath].datos_afiliado.apellido1, apellido2: this.dataForm[this.namePath].datos_afiliado.apellido2, tipo:  this.gettersDatalist('list_tipo',this.dataForm[this.namePath].info_afiliacion.id_list_tipo)[0].codigo, subtipo: this.gettersDatalist('list_subtipo',subtipo)[0].codigo, horas: 0, extranjero: null, colextranjero: null, fechaextranjero: null,codigoccf: this.codigo.Ccf, codigoafp: this.codigo.Afp,codigoeps: this.codigo.Eps, diasafp: diaspensionPlano, diaseps: diasAportes, diasriesgo: diasAportes,diasccf: diasAportes, diasparafiscales: null, salario: this.dataForm[this.namePath].info_afiliacion.salario, salariointegral: null, ibcafp: this.ibc.Afp, ibceps: this.ibc.Eps, ibcriesgo: this.ibc.Riesgo, ibcccf: this.ibc.Ccf, ibcparafiscales: null, tarifaafp: this.tarifa.Afp, tarifaaltoriesgo: null, cotizacionafp: this.cotizacion.Afp, voluntariaaportante: null, voluntariaafiliado: null, totalafp: null, solidaridadafp: null, subsistencia: null, retenido: null, tarifaeps: this.tarifa.Eps, cotizacioneps: this.cotizacion.Eps, incapacidadeg: null, valoreg: null, licencia: null, valorlicencia: null, valorupc: null, tarifariesgo: this.tarifa.Riesgo, claseriesgo: this.claseriesgo, centrotrabajo: null, cotizacionriesgo: this.cotizacion.Riesgo, epsdestino: null, afpdestino: null, tarifasena: null, cotizacionsena: null, tarifaicbf: null, cotizacionicbf: null, tarifaccf: this.tarifa.Ccf, cotizacionccf: this.cotizacion.Ccf, tarifaesap: null, cotizacionesap: null, tarifamen: null, cotizacionmen: null, exonerado: exonerado, ingreso: ingresoPlano, fechaingreso: fechaingresoPlano, retiro: retiroPlano, fecharetiro: fecharetiroPlano, tda: null, taa: null, vsp: null, iniciovsp: null, vst: null, sln: null, iniciosln: null, finsln: null, ige: null, inicioige: null, finige: null, lma: null, iniciolma: null, finlma: null, vaclr: null, iniciovaclr: null, finvaclr: null, avp: null, vct: null, iniciovct: null, finvct: null, vip: null, corecciones: null, irl: null, inicioirl: null, finirl: null, fecha: fechaArchivo, servicios: this.dataForm[this.namePath].archivo_plano.servicios, aporte: this.totalAportes,dias: diasAportes,planilla:null,fechaplanilla:null,id_list_novedad: novedadAportes,id_list_mes: this.dataForm[this.namePath].info_aportes.id_list_mes, id_list_ano: this.dataForm[this.namePath].info_aportes.id_list_ano,id_datos_afiliado: null,id_info_aportes: null,id_aportes_registro: null,id_info_afiliacion: null,id_datos_razon: null,id_datos_asesor: null,id_datos_contacto: null}

          if(this.dataForm[this.namePath].descuentos_referido===null)
          {
            const await39 = this.updateDataForm({ state: 'info_afiliacion', data: this.dataForm[this.namePath].info_afiliacion})    
            const await40 = this.updateDataForm({ state: 'archivo_plano', data: dataArchivoPlano})        
            const await41 = this.updateDataForm({state: 'aportes_registro/valor', data: this.dataForm[this.namePath].info_aportes.valor})
            const await42 = this.updateDataForm({state: 'aportes_registro/fecha', data: this.dataForm[this.namePath].info_aportes.fecha}) 
            const await47 =  this.updateDataForm({state: 'aportes_registro/mes_periodo', data: this.dataForm[this.namePath].info_aportes.id_list_mes})
            const await48 =  this.updateDataForm({state: 'aportes_registro/ano_periodo', data: this.dataForm[this.namePath].info_aportes.id_list_ano})
            const await49 =  this.updateDataForm({state: 'aportes_registro/id_list_novedad', data: novedadAportes})
            const await50 =  this.updateDataForm({state: 'aportes_registro/reporte', data: this.totalAportes}) 

            await Promise.all([await39,await40,await41,await42,await47,await48,await49,await50])
          }  
          else {            
            const await39 = this.updateDataForm({ state: 'info_afiliacion', data: this.dataForm[this.namePath].info_afiliacion})    
            const await40 = this.updateDataForm({ state: 'archivo_plano', data: dataArchivoPlano})        
            const await41 = this.updateDataForm({state: 'aportes_registro/valor', data: this.dataForm[this.namePath].info_aportes.valor-this.dataForm[this.namePath].descuentos_referido.descuento<0 ? 0 : this.dataForm[this.namePath].info_aportes.valor-this.dataForm[this.namePath].descuentos_referido.descuento })
            const await42 = this.updateDataForm({ state: 'info_aportes/valor', data: this.dataForm[this.namePath].aportes_registro.valor})  
            const await43 = this.updateDataForm({ state: 'info_aportes/id_descuentos_referido', data: this.dataForm[this.namePath].descuentos_referido.id})  
            const await44 = this.updateDataForm({state: 'aportes_registro/fecha', data: this.dataForm[this.namePath].info_aportes.fecha}) 
            const await45 = this.updateDataForm({state: 'descuentos_referido/deleted_at', data: this.fecha().fecha.delete}) 
            const await46 = this.updateDataForm({state: 'descuentos_referido/nota_delete', data: 'ya fue descontado'})
            const await47 =  this.updateDataForm({state: 'aportes_registro/mes_periodo', data: this.dataForm[this.namePath].info_aportes.id_list_mes})
            const await48 =  this.updateDataForm({state: 'aportes_registro/ano_periodo', data: this.dataForm[this.namePath].info_aportes.id_list_ano})
            const await49 =  this.updateDataForm({state: 'aportes_registro/id_list_novedad', data: novedadAportes})
            const await50 =  this.updateDataForm({state: 'aportes_registro/reporte', data: this.totalAportes}) 
            await Promise.all([await39,await40,await41,await42,await43,await44,await45,await46,await47,await48,await49,await50])
          } 
          this.$emit('save',{save:event.save, ftn: 'aportesFtn' })
        }
      }
      catch(e)
      {
        console.log('error in save aportes aportes registro',e)
      }
    },
    changeFecha()
    {
      if(this.fechaAdelantado)
      {
        this.fechaPago=this.fecha(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-01').inicioLabores.servicios
      }
      else 
      {
        this.fechaPago=this.fecha().fecha.minHoy
      }
    }
  }
}
</script>
<style>
.tabs-sw{
    padding-left: 10px;
    width: 100%;
    padding-top: 12px;
    border-radius: 3px 3px 0 0;
    border: 1px solid #dee2e6;
    background-color: rgba(0,0,0,.03);
}
.tabs-sw .nav-link.active{
  background:white;
} 
</style>